<template>
  <v-app>     
    <v-layout>
      <Navbar />         
      <v-content>   
        <EditAccount />
       
        <Footer /> 
      </v-content>
      <RightNavbar />  
    </v-layout>
  </v-app>
</template>

<script>
  import Navbar from '@/components/shop/navbar/Navbar'
  import RightNavbar from '@/components/shop/navbar/RightNavbar'
  import EditAccount from  '@/components/shop/account/EditAccount'
  import Feature from  '@/components/shop/sections/Feature'
  import Footer from  '@/components/shop/sections/Footer'    
  import db from '@/firebase/init'
  import moment from 'moment'
  export default {
    name:'Home',
    components:{
      Navbar,RightNavbar,EditAccount,Feature,Footer
    },
    data(){
      return{
      
      }
    },
    created(){

    } 
  }
</script>


// WEBPACK FOOTER //
// src/components/shop/pages/EditAccount.vue